export default "__VITE_ASSET__DjzJz98B__"